import React from "react";
import { Avatar, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";
import styled from "styled-components";

const AvatarIcon = styled(UserOutlined)`
  font-size: 2.5rem;
`;

export type PartnerProps = {};

const Partner: React.FC<
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > &
    PartnerProps
> = (props) => {
  const { className, ...rest } = props;
  return (
    <div
      className={`border-l-4 bg-white py-2 px-4 w-full ${
        className ?? ""
      }`}
      {...rest}
    >
      <Space>
        <Avatar
          className="cursor-pointer w-10 h-10"
          size={"default"}
          icon={<AvatarIcon />}
        />
        <div className="leading-tight">
          <span className="block font-bold text-base">John doe</span>
          <span className="">1994 - Living</span>
        </div>
      </Space>
    </div>
  );
};

export default Partner;
